/* @flow */

import type { Storage } from "crustate";
import type { Client } from "@awardit/graphql-ast-client";
import type { PopularRequest, PopularResponse } from "@crossroads/shop-state/popular";

import { POPULAR_REQUEST, POPULAR_RESPONSE } from "@crossroads/shop-state/popular";
import { popular } from "queries";

import { PAGE_SIZE, loadCampaignAwareProductList } from "./product-list-pagination";

const registerClient = (storage: Storage, client: Client<{}>) => {
  storage.addEffect({
    effect: async (msg: PopularRequest) => {
      const { popularProducts } = await loadCampaignAwareProductList({
        client,
        query: popular,
        variables: {
          filter: msg.filters,
          page: msg.page !== null ? msg.page : 1,
          pageSize: PAGE_SIZE,
        },
        productsPerRow: (msg: any).productsPerRow,
        productListPath: "popularProducts",
        pathname: "/popular-products",
      });

      return ({
        tag: POPULAR_RESPONSE,
        data: popularProducts,
      }: PopularResponse);
    },
    subscribe: { [POPULAR_REQUEST]: true },
  });
};

export default registerClient;
